export default __webpack_public_path__ + "static/media/pragma-logo.7668b6be.svg";